import typeToReducer from 'type-to-reducer';
import get from 'lodash.get';
import capitalize from 'lodash.capitalize';

import * as actions from './actions';

const initialState = {
  err: false,
  errMsg: '',
  loading: false,
  success: false,
};

export default typeToReducer(
  {
    [actions.DELETE_ACCOUNT]: {
      PENDING: (state) => ({
        ...state,
        loading: true,
      }),
      FULFILLED: (state) => ({
        ...state,
        loading: false,
        success: true,
      }),
      REJECTED: (state, action) => {
        const response = get(action, 'payload.response', {});
        const errMsg = capitalize(response.data);

        return {
          ...state,
          loading: false,
          success: false,
          err: true,
          errMsg,
        };
      },
    },
  },
  initialState,
);
